export default __webpack_public_path__ + "58461ec88fa477b517783e32d5117929.png";